$(document).on('submit', '.dnGuestlistEntryForm', function (e) {
    e.preventDefault();

    var form = $(this);
    var url = form.attr('action');

    var buttons = form.find('button');

    var enableLoadingButton = function () {
        buttons.each(function () {
            $(this).enableLoadingAnimation(true);
        });
    };

    var disableLoadingButton = function () {
        buttons.each(function () {
            $(this).enableLoadingAnimation(false);
        });
    };

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        beforeSend: function () {
            enableLoadingButton();
        },
        success: function (response) {
            var responseHtml = $($.parseHTML(response)).find(".dnGuestlistForm-container");

            if (responseHtml.length) {
                var container = $('.dnGuestlistForm-container');
                container.html(responseHtml.html());
            }
            disableLoadingButton();
        },
        error: function () {
            disableLoadingButton();
        }
    });
});


$(document).on('click', '.dnGuestlistEntry-icon', function (e) {
    e.preventDefault();

    var button = $(this);
    var container = button.closest('.dnGuestlistEntry');

    $.get(button.data('url'), function () {
        if (button.hasClass('dnGuestlistEntry-icon-delete')) {

            container.addClass('dnGuestlistEntry-deleted');
            $('.dnGuestlistEntryList-table').append(container);

        } else if (button.hasClass('dnGuestlistEntry-icon-check')) {

            container.removeClass('dnGuestlistEntry-deleted');
            var first_deleted_entry = $('.dnGuestlistEntry-deleted:first');
            if (first_deleted_entry.length) {
                first_deleted_entry.before(container);
            }

        }
    });
});
